export const RATIO_CODE = {
  TOTAL_DEPOSIT: 'BS178',
  TOTAL_CREDIT: 'BS158',
  DEPOSIT_GROWTH: 'RT0297',
  CREDIT_GROWTH: 'RT0296',
}

export const TREND_DATA = [
  { value: RATIO_CODE.TOTAL_DEPOSIT, color: '#006AA6', isBarChart: true },
  { value: RATIO_CODE.TOTAL_CREDIT, color: '#FFCD60', isBarChart: true },
  { value: RATIO_CODE.DEPOSIT_GROWTH, color: '#4EB1CB', isLineChart: true },
  { value: RATIO_CODE.CREDIT_GROWTH, color: '#F49966', isLineChart: true },
]
